<template>
  <section class="what-we-do-section">
    <div class="container">
      <div class="row title-wrapper no-gutters">
        <div class="col-sm-6 wow fadeInLeft" data-wow-duration="1s" data-wow-delay=".5s">
          <span v-bind="$parent.dKey('b3subtitle')" class="section-title">{{subtitle}}</span>
          <h2 v-bind="$parent.dKey('b3title')">{{title}}</h2>
        </div>
        <div v-bind="$parent.dKey('b3titleRight')" class="col-sm-6 text-right big-title-st resp-number wow fadeInRight" data-wow-duration="2s" data-wow-delay=".5s" v-html="bgTitle"></div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row services-overview-wrapper">
        <ServiceArticle v-for="(article, index) in services"
                        v-bind:index="index"
                        v-bind:title="article.title"
                        v-bind:content="article.content"
                        v-bind:href="article.link"
                        v-bind:image="article.image"
                        v-bind:linkText="article.linkText" />
      </div>
    </div>
  </section>
</template>

<script>

import ServiceArticle from './ServiceArticle.vue'

export default {
  name: 'WhatWeDo',

  props: ['title', 'subtitle', 'bgTitle', 'services'],

  components: {
    ServiceArticle
  },

  created() {
    // console.log(this)
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    }
  }
}

</script>